import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import { FC } from 'react';

import { PreviewItem } from '../../utils/storyblok/stories';
import { GlossaryReference } from './GlossaryReference';

interface Props {
  className?: string;
  items: PreviewItem[];
  term: string;
}

export const GlossaryResults: FC<Props> = ({
  className = '',
  items = [],
  term,
}) => {
  const { t } = useTranslation('glossary');

  if (items.length === 0) {
    return null;
  }

  return (
    <section className={className}>
      <h2 className="mb-3 text-neutral-4">
        {t('resultsFor', { count: items.length, term })}
      </h2>
      <div className="flex flex-col">
        {items.map((item) => (
          <Link
            key={item.uuid}
            className="group border-t border-divider/20 py-3 last:pb-0"
            href={`/${item.full_slug}`}
            prefetch={false}
          >
            <GlossaryReference item={item} />
          </Link>
        ))}
      </div>
    </section>
  );
};
